import React from "react"
import ReactDOM from "react-dom"
import { createHashRouter, RouterProvider } from "react-router-dom"
import SelfCheckout from "./SelfCheckout"

document.addEventListener("DOMContentLoaded", function () {
  const element = document.getElementById("pingvin_checkout")
  if (typeof element !== "undefined" && element !== null) {
    ReactDOM.render(<SelfCheckout />, document.getElementById("pingvin_checkout"))
  }
})
